export default "__VITE_ASSET__BrsMARF7__"